import styled from 'styled-components';
import { Button as StyledButton } from '../Button/Button.styled';

export const ShopButtons = styled.div`
  display: flex;
  flex-direction: column;
  width: 210px;
  margin: 0 auto;
  row-gap: ${(props) => (props.hasLargeButtonGap ? '16px' : '8px')};
`;

export const CTAButton = styled(StyledButton).attrs(({ variant, size }) => ({
  variant: variant || 'defaultDark',
  size: size || 'regular'
}))`
  width: 100%;
`;
